"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FinanceDetailsRows;
(function (FinanceDetailsRows) {
    FinanceDetailsRows["DEPOSIT"] = "deposit";
    FinanceDetailsRows["DEPOSIT_PERCENTAGE"] = "depositPercentage";
    FinanceDetailsRows["RESIDUAL_AMOUNT"] = "residualAmount";
    FinanceDetailsRows["AMOUNT_FINANCED"] = "amountFinanced";
    FinanceDetailsRows["PAYMENT_VALUE"] = "paymentValue";
    FinanceDetailsRows["FINANCE_PRODUCT_NAME"] = "financeProductName";
    FinanceDetailsRows["TERM"] = "term";
    FinanceDetailsRows["MILEAGE"] = "mileage";
    FinanceDetailsRows["AMOUNT_PAYABLE"] = "amountPayable";
    FinanceDetailsRows["TOTAL_AMOUNT_PAYABLE"] = "totalAmountPayable";
    FinanceDetailsRows["INTEREST_RATE"] = "interestRate";
    FinanceDetailsRows["NET_DRIVEAWAY_PRICE"] = "netDriveawayPrice";
    FinanceDetailsRows["UPFRONT_FEES"] = "upfrontFees";
    FinanceDetailsRows["LOAN_TYPE"] = "loanType";
    FinanceDetailsRows["COMPARISON_RATE"] = "comparisonRate";
    FinanceDetailsRows["REPAYMENT"] = "repayment";
    FinanceDetailsRows["RESIDUAL_PAYMENT"] = "residualPayment";
    FinanceDetailsRows["TOTAL_PURCHASE_AMOUNT"] = "totalPurchaseAmount";
    FinanceDetailsRows["ESTABLISHMENT_FEE"] = "establishmentFee";
    FinanceDetailsRows["LOAN_TERM_PERIOD"] = "loanTermPeriod";
    FinanceDetailsRows["GOVERNMENT_EV_REBATE"] = "governmentEVRebate";
    FinanceDetailsRows["NONFINANCEABLE_AMOUNT"] = "totalNonFinanceableFeatures";
})(FinanceDetailsRows = exports.FinanceDetailsRows || (exports.FinanceDetailsRows = {}));
